// extracted by mini-css-extract-plugin
module.exports = {"container":"Sales_container__2vdEi","heading":"Sales_heading__1l3tM","membersContainer":"Sales_membersContainer__3S30A"};